/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Site_Url_Error_EmptyInputs */

const en_site_url_error_empty = /** @type {(inputs: Site_Url_Error_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a website address.`)
};

const id_site_url_error_empty = /** @type {(inputs: Site_Url_Error_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isi alamat website.`)
};

/**
* | output |
* | --- |
* | "Enter a website address." |
*
* @param {Site_Url_Error_EmptyInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const site_url_error_empty = /** @type {((inputs?: Site_Url_Error_EmptyInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_Url_Error_EmptyInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_site_url_error_empty(inputs)
	return en_site_url_error_empty(inputs)
});